/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Defines the reason why the rebalancing plan failed.  * `rebalancing_plan_generation_failed` - the rebalancing plan generation failed. * `upscaling_failed` - the upscaling of the cluster failed. * `node_drain_failed` - the drain of a node failed. * `node_create_failed` - the creation of a node failed. * `node_prepare_failed` - the preparation of a node failed. * `node_delete_failed` - the deletion of a node failed. * `rebalancing_plan_timeout` - the rebalancing plan timed out. * `achieved_savings_below_threshold` - the achieved savings are below the threshold. * `unknown` - the reason is unknown. * `insufficient_capacity` - the cloud provider had insufficient capacity for the requested instance type(s). * `canceled_by_user` - the rebalancing plan was explicitly canceled by user. * `plan_is_not_runnable` - the rebalancing plan is not runnable. * `subnet_is_full` - the subnet has no available IP addresses left.
 * @export
 * @enum {string}
 */

export const CastaiAutoscalerV1beta1RebalancingPlanResponsePlanErrorReason = {
    invalid: 'invalid',
    rebalancingPlanGenerationFailed: 'rebalancingPlanGenerationFailed',
    upscalingFailed: 'upscalingFailed',
    nodeDrainFailed: 'nodeDrainFailed',
    nodeCreateFailed: 'nodeCreateFailed',
    nodePrepareFailed: 'nodePrepareFailed',
    nodeDeleteFailed: 'nodeDeleteFailed',
    rebalancingPlanTimeout: 'rebalancingPlanTimeout',
    achievedSavingsBelowThreshold: 'achievedSavingsBelowThreshold',
    unknown: 'unknown',
    insufficientCapacity: 'insufficientCapacity',
    canceledByUser: 'canceledByUser',
    planIsNotRunnable: 'planIsNotRunnable',
    subnetIsFull: 'subnetIsFull'
} as const;

export type CastaiAutoscalerV1beta1RebalancingPlanResponsePlanErrorReason = typeof CastaiAutoscalerV1beta1RebalancingPlanResponsePlanErrorReason[keyof typeof CastaiAutoscalerV1beta1RebalancingPlanResponsePlanErrorReason];



